<template>
  <div class="overseaRecharge">
      <CopyDesc :title="title" :orderList='orderList'></CopyDesc>
      
      <div class="wrapp">
        <div class="titlep">{{$t('other.a2173')}}：</div>
        <div class="imgbox">
            <img src="https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/20210730154838.png" alt="">

        </div>
      </div>

  </div>
</template>

<script>
export default {
data(){
return{
    title:this.$t('other.a1074'),
    orderList:[{
        label:this.$t('other.a2174'),
        desc:this.$t('other.a2175'),
    },{
        label:this.$t('other.a2176'),
        desc:this.$t('other.a2177'),
    },{
        label:this.$t('other.a2178'),
        desc:this.$t('other.a2179'),
    },{
        label:this.$t('other.a2180'),
        desc:this.$t('other.a2181'),
    },]


}
},
components: {
  CopyDesc:() => import(`./components/copyDesc`),
  
   

},
create(){

},
methods:{

}
}

</script>
<style lang="scss" scoped>
.overseaRecharge{
    margin-bottom: 50px;
    .wrapp{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .titlep{
            font-size: 28px;
            font-weight: 600;
            margin: 50px 0 10px 0;
        }
        
    }
    .imgbox{
        width: 800px;
        height: 700px;
        overflow: hidden;

        img{
            width: 100%;
        }
    }
}
</style>